export interface RelativeDataLabels {
  on: string
  off: string
}

export const DEFAULT_RELATIVE_DATA_LABELS: RelativeDataLabels = {
  on: 'Show absolute values',
  off: 'Show relative values',
}
